export const appearAndExit = {
    open: {
        height: 'auto', opacity: 1, transition: {
            duration: 0.5, ease: "easeInOut"
        },
    }, closed: {
        height: 0, opacity: 0, transition: {
            duration: 0.5, ease: "easeInOut"
        },
    },
};

// maybe change to duration based instead of physics based cause duration actually makes sense to me
export const enterRightExitLeft = {
    initial: {
        x: '100%', // Start off-screen to the right
        opacity: 0, // Start with no opacity
    },
    open: {
        x: 0, // Animate to the center
        opacity: 1, // Fully visible
        transition: {
            type: 'spring',
            stiffness: 100,
            damping: 20,
        },
    },
    exit: {
        x: '-100%', // Animate off-screen to the left
        opacity: 0, // Fade out
        transition: {
            type: 'spring',
            stiffness: 200,
            damping: 20,
        },
    },
};
